import PropTypes from 'prop-types';

import './styles/buttonGroupStyles.css';

const ButtonGroup = ({ children, className }) => (
  <div className={`button-group ${className || ''}`}>{children}</div>
);

ButtonGroup.defaultProps = {
  className: '',
};

ButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ButtonGroup;
